import React, { createContext, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../store/slices/authSlice';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
  const dispatch = useDispatch();
  
  const updateUser = (updatedUser) => {
    console.log('Updating user state with:', updatedUser);
    // Ensure we're not losing any existing user data
    const currentUser = user || {};
    const newUser = { ...currentUser, ...updatedUser };
    console.log('New user state:', newUser);
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
    
    // Also update Redux store to keep it in sync
    const token = localStorage.getItem('token');
    if (token) {
      dispatch(loginSuccess({ user: newUser, token }));
    }
  };

  const login = (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    dispatch(loginSuccess({ user, token }));
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    dispatch({ type: 'auth/logout' });
  };

  return (
    <AuthContext.Provider value={{ user, updateUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};